import { createContext } from 'react';

export type CoreContextType = {
  fastMode?: boolean;
};

export const CoreContext = createContext<CoreContextType | null>(null);
